<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Cambio"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-map :markers="markers" />
      <o-section-header title="Nieuwe reservatie">
        <template #right>
          <o-icon
            icon="support2"
            @click.native="showOverlay('supportOverlay')"
          />
          <o-icon icon="info" @click.native="showOverlay('infoOverlay')" />
        </template>
      </o-section-header>
      <o-cambio-reservation-form
        @editLocation="showOverlay('location')"
        @editStand="showOverlay('stand')"
        @standInfo="showStandInfo"
        @editKlasse="showOverlay('klasse')"
        @klasseInfo="showKlasseInfo"
        @editDistance="showOverlay('distance')"
        @editOptions="showOverlay('options')"
      />
    </o-view>
    <o-pay-button
      label="Bekijk beschikbaarheden"
      @click="showOverlay('kilometersOverlay')"
    />
    <o-overlay title="Locatie" ref="location">
      <template #form>
        <o-edit-location @click.native="hideOverlay('location')" />
      </template>
    </o-overlay>
    <o-overlay title="Standplaats" ref="stand">
      <template #form>
        <o-edit-stand @click.native="hideOverlay('stand')" />
      </template>
    </o-overlay>
    <o-overlay title="Wagenklasse" ref="klasse">
      <template #form>
        <o-edit-klasse @click.native="hideOverlay('klasse')" />
      </template>
    </o-overlay>
    <o-overlay title="Opties en toebehoren" ref="options">
      <template #form>
        <o-edit-options />
      </template>
      <o-button
        label="Wijziging bevestigen"
        :is-primary="true"
        @click="hideOverlay('options')"
      />
    </o-overlay>
    <o-overlay ref="kilometersOverlay">
      <template #form>
        <o-edit-distance />
      </template>

      <o-button
        label="Bevestigen"
        to="/sales/car/cambio/reservations/new-alternatives"
        :is-primary="true"
        :full="true"
      />
    </o-overlay>
    <o-overlay ref="infoOverlay">
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut consectetur
        accumsan libero. Nullam quis elit at metus viverra tempor. Vivamus metus
        magna, dapibus at lacus et, tincidunt cursus tellus.
      </p>
    </o-overlay>
    <o-overlay title="Support" ref="supportOverlay">
      <div class="c-bottom-overlay__list">
        <o-list-item
          icon="link"
          label="Meest gestelde vragen"
          :chevron="false"
        />
      </div>
    </o-overlay>
  </o-view>
</template>

<script>
import OCambioReservationForm from '@/components/OCambioReservationForm.vue'
import OMap from '@/components/OMap.vue'
import OPayButton from '@/components/OPayButton.vue'
import OEditDistance from '@/components/overlays/OEditDistance.vue'
import OEditLocation from '@/components/overlays/OEditLocation.vue'
import OEditStand from '@/components/overlays/OEditStand.vue'
import OEditKlasse from '@/components/overlays/OEditKlasse.vue'
import OEditOptions from '@/components/overlays/OEditOptions.vue'
export default {
  name: 'CambioEdit',
  components: {
    OEditOptions,
    OEditKlasse,
    OEditStand,
    OEditLocation,
    OEditDistance,
    OCambioReservationForm,
    OMap,
    OPayButton
  },
  data() {
    return {
      markers: [
        {
          coordinates: [3.715, 51.05],
          type: 'cambio',
          title: 'Cambio A',
          link: 'poi/cambio'
        },
        {
          coordinates: [3.723, 51.053],
          type: 'cambio',
          title: 'Cambio B',
          link: 'poi/cambio'
        },
        {
          coordinates: [3.72, 51.055],
          type: 'cambio',
          title: 'Cambio C',
          link: 'poi/cambio'
        }
      ]
    }
  },

  methods: {
    showStandInfo() {
      this.$router.push({ name: 'providerscambiostandinfo' })
    },

    showKlasseInfo() {
      this.$router.push({ name: 'providerscambioclassinfo' })
    }
  }
}
</script>
